import Vue from 'vue'
import VueRouter from 'vue-router'

import toolsUtils from "@/common/toolsUtils.js"
import { Message } from 'element-ui';
import CryptoJS from "crypto-js"
import store from '../store'
import watermark from 'watermark-dom'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/other',
            name: 'other',
            component: () => import("@/pages/other/other.vue"),
            children: [
                {
                    path: '/',
                    components: {
                        other: () => import("@/pages/other/info.vue")
                    }
                },
                {
                    path: 'info',
                    name: 'info',
                    components: {
                        other: () => import("@/pages/other/info.vue")
                    }
                },
                {
                    path: 'tips',
                    name: 'tips',
                    components: {
                        other: () => import("@/pages/other/tips.vue")
                    }
                }
            ]
        },

        {
            path: '/',
            name: 'index',
            component: () => import("@/pages/main/index.vue"),
            children: [
                {
                    path: '/',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/home.vue")
                    }
                },
                {
                    path: 'home',
                    name: 'home',
                    meta: {
                        isLogin: true,
                        role: [0,1],
                    },
                    components: {
                        main: () => import("@/pages/home.vue")
                    }
                },
                {
                    path: 'detail',
                    name: 'detail',
                    
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/detail.vue")
                    }
                    // props: route =>route.query
                },
                {
                    path: 'day_practice',
                    name: 'day_practice',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/day/day_practice.vue")
                    }
                    // props: route =>route.query
                },
                {
                    path: 'day_print',
                    name: 'day_print',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/day/day_print.vue")
                    }
                    // props: route =>route.query
                },
				{
				    path: 'day_print_spelling',
				    name: 'day_print_spelling',
				    meta: {
				        isLogin: true,
				        role: [0,1]
				    },
				    components: {
				        main: () => import("@/pages/day/day_print_spelling.vue")
				    }
				    // props: route =>route.query
				},
				{
				    path: 'day_print2',
				    name: 'day_print2',
				    meta: {
				        isLogin: true,
				        role: [0,1]
				    },
				    components: {
				        main: () => import("@/pages/day/day_print2.vue")
				    }
				    // props: route =>route.query
				},
				{
				    path: 'day_print3',
				    name: 'day_print3',
				    meta: {
				        isLogin: true,
				        role: [0,1]
				    },
				    components: {
				        main: () => import("@/pages/day/day_print3.vue")
				    }
				    // props: route =>route.query
				},
                {
                    path: 'vocabulary_test',
                    name: 'vocabulary_test',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/vocabularyTest.vue")
                    }
                },
                {
                    path: 'vocabulary_test2',
                    name: 'vocabulary_test2',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/vocabularyTest2.vue")
                    }
                },
                // props: route =>route.query
                {
                    path: 'vocabulary_testlist',
                    name: 'vocabulary_testlist',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/vocabularyTestList.vue")
                    }
                    // props: route =>route.query
                },
                {
                    path: 'vocabulary_testreport',
                    name: 'vocabulary_testreport',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/vocabularyTestReport.vue")
                    }
                    // props: route =>route.query
                },
                {
                    path: 'collection',
                    name: 'collection',
                    meta: {
                        isLogin: true,
                        role: [0]
                    },
                    components: {
                        main: () => import("@/pages/collection.vue")
                    }
                    // props: route =>route.query
                },
                {
                    path: 'excellent_student',
                    name: 'excellent_student',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/excellent_student.vue")
                    }
                    // props: route =>route.query
                },
                {
                    path: 'abou_us',
                    name: 'abou_us',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/abou_us.vue")
                    }
                    // props: route =>route.query
                },
                {
                    path: 'day_study',
                    name: 'day_study',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/day/day_study.vue")
                    }
                    // props: route =>route.query
                },
                {
                    path: 'word_recognise',
                    name: 'word_recognise',
                    meta: {
                        isLogin: true,
                        role: [0,1]
                    },
                    components: {
                        main: () => import("@/pages/wordRecognise.vue")
                    }
                    // props: route =>route.query
                },
				{
				    path: 'vocabularyTest2',
				    name: 'vocabularyTest2',
				    meta: {
				        isLogin: true,
                        role: [0,1]
				    },
				    components: {
				        main: () => import("@/pages/vocabularyTest2.vue")
				    }
				    // props: route =>route.query
				},
				{
				    path: 'attend_class_list',
				    name: 'attend_class_list',
				meta: {
				    isLogin: true,
				    role: [0,1]
				},
				    components: {
				        main: () => import("@/pages/attend_class_list.vue")
				    }
				    // props: route =>route.query
				},
				{
				    path: 'attend_class_list2',
				    name: 'attend_class_list2',
				meta: {
				    isLogin: true,
				    role: [0,1]
				},
				    components: {
				        main: () => import("@/pages/attend_class_list2.vue")
				    },
				    // props: route =>route.query
				},
				{
				    path: 'attend_class_list3',
				    name: 'attend_class_list3',
				meta: {
				    isLogin: true,
				    role: [0,1]
				},
				    components: {
				        main: () => import("@/pages/attend_class_list3.vue")
				    },
				    // props: route =>route.query
				},
				{
				    path: 'phonetic_alphabet_recognition',
				    name: 'phonetic_alphabet_recognition',
				meta: {
				    isLogin: true,
				    role: [0,1]
				},
				    components: {
				        main: () => import("@/pages/phonetic_alphabet_recognition.vue")
				    },
				    // props: route =>route.query
				},
				{
				    path: 'class_record',
				    name: 'class_record',
				meta: {
				    isLogin: true,
				    role: [0,1]
				},
				    components: {
				        main: () => import("@/pages/class_record.vue")
				    },
				    // props: route =>route.query
				},
				{
				    path: 'class_record2',
				    name: 'class_record2',
				meta: {
				    isLogin: true,
				    role: [0,1]
				},
				    components: {
				        main: () => import("@/pages/class_record2.vue")
				    },
				    // props: route =>route.query
				},
                {
				    path: 'application_beststudent',
				    name: 'application_beststudent',
                    meta: {
                        isLogin: true,
                        role: [1]
                    },
				    components: {
				        main: () => import("@/pages/application_beststudent.vue")
				    },
				    // props: route =>route.query
				},
				
				{
				    path: 'class_read',
				    name: 'class_read',
				    meta: {
				        isLogin: true,
				        role: [1]
				    },
				    components: {
				        main: () => import("@/pages/class_read.vue")
				    },
				    // props: route =>route.query
				},
				{
				    path: 'class_readppt',
				    name: 'class_readppt',
				    meta: {
				        isLogin: true,
				        role: [1]
				    },
				    components: {
				        main: () => import("@/pages/class_readppt.vue")
				    },
				    // props: route =>route.query
				},
            ]
        },

        {
            path: '/login',
            name: 'login',
            meta: {
                isLogin: false,
                role: [0,1]
            },
            component: () => import("@/pages/login.vue")
        },
        {
            path: "/404",
            name: "404",
            meta: {
                isLogin: false,
                role: [0,1]
            },
            component: () => import('@/pages/404.vue')
        },
        //放最后面，不可以改变顺序
        {
            path: '*',
            redirect: { name: "404" },
            hidden: true
        }
    ]
})

//全局路由守卫
router.beforeEach((to, from, next) => {
   console.log("~~~~~~~~~~~~~~~~~~~~"+to.name);
   if(to.name=="day_print")
   {
		document.title="中英文";
   }else{
		document.title="简易读教育";
   }

    let userToken = toolsUtils.getCookiesSync("user_token");
    let user_info = null;
    if(toolsUtils.getCookiesSync("user_info")){
        user_info = CryptoJS.AES.decrypt(toolsUtils.getCookiesSync("user_info"), 'jfgas12444#####').toString(CryptoJS.enc.Utf8); 
        user_info = JSON.parse(user_info);
    }
    
    if (to.name != 'login' && toolsUtils.isObjEmpty(userToken) && to.meta.isLogin) {
        if (toolsUtils.getStorageSync("accountLogin")) {
            Message({
                type: 'error',
                message: "用户登录信息已过期，请重新登录"
            });
            store.commit("logoutUser");
        }
        next({ path: "/login" })
    } else if( to.name != 'login' && to.meta.role.indexOf(Number(user_info.role)) > -1) {
        next()
    }else if(to.name != 'login') {
        next({
            path: "404"
        })
    }else {
        next()
    }

	// setTimeout(()=>{ 
	// 		if(user_info&&!toolsUtils.isObjEmpty(userToken))
	// 		{
	// 			watermark.load({watermark_txt:user_info.userName+" "+user_info.loginName+" 测试环境"});
	// 		}else{
	// 			watermark.load({watermark_txt:"测试环境"});
	// 		}
	// 	},1000)

});


//4.向外共享路由的实例对象
export default router;